export const VALID_TABS = new Set([
  "beranda",
  "cermati",
  "eksplorasi",
  "rancang",
  "desain",
  "asah",
  "sebar",
  "panduan",
  "tutorial",
  "bahan",
]);

export const LEARNING_STAGES = [
  { tab: "cermati", step: 1, label: "Cermati" },
  { tab: "eksplorasi", step: 2, label: "Eksplorasi" },
  { tab: "rancang", step: 3, label: "Rancang" },
  { tab: "desain", step: 4, label: "Desain" },
  { tab: "asah", step: 5, label: "Asah" },
  { tab: "sebar", step: 6, label: "Sebar" },
];

export function tabFromSearchParams(searchParams) {
  const tab = searchParams.get("tab");
  return tab && VALID_TABS.has(tab) ? tab : "beranda";
}

export function postAuthorId(post) {
  if (!post?.userId) return null;
  return typeof post.userId === "object" ? post.userId._id || post.userId.id : post.userId;
}
